/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUserLabTestItem } from 'app/shared/model/user-lab-test-item.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';

export interface IUserPanelItem {
  id?: string;
  active?: boolean | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  cursor?: number;
  item?: IUserLabTestItem | null;
  panel?: IDiagLabPanel | null;
}

export const defaultValue: Readonly<IUserPanelItem> = {
  active: false,
};
